import React from "react";
import { Modal, Button } from "react-bootstrap";
import { ExclamationTriangleFill } from "react-bootstrap-icons";

const VOMPendingModal = ({ show, onClose, pendingCount, onSign }) => {
  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="vom-modal"
    >
      <div className="p-5">
        {/* Header */}
        <div className="d-flex align-items-start mb-3 p-5">
          <ExclamationTriangleFill
            className="mt-2 me-2"
            color="#dc3545"
            size={25}
          />
          <div>
            <h4 className="text-error mb-1 fw-semibold">
              Verification of Mortgage
            </h4>
            <p className="text-error m-0">
              You have {pendingCount} VOM request(s) pending for signature.
            </p>
          </div>
        </div>

        {/* Pending Card */}
        <div className="p-5 rounded mb-5" style={{ background: "#fdecec" }}>
          <p className="fw-semibold text-secondary mb-1">Pending Requests</p>
          <h2 className="fw-bold text-dark m-0">{pendingCount}</h2>
        </div>

        {/* Info text */}
        <p className="text-secondary mb-5">
          To proceed with the mortgage application process, all verification
          requests must be completed and signed.
        </p>

        {/* CTA Buttons */}
        <div className="d-flex gap-5 py-5">
          <Button
            variant="light"
            className="flex-grow-1 border btn-modern-outline p-5 fw-semibold"
            onClick={onClose}
          >
            Remind Me Later
          </Button>

          <Button
            className="flex-grow-1 py-2 fw-semibold text-white bg-primary border-color-primary btn-modern-outline"
            onClick={onSign}
          >
            Sign Verification Requests
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default VOMPendingModal;
